/**
 * Returns a new array with n elements removed from the right.
 */
const dropRight = (arr, n = 1) => arr.slice(0, -n);

export default dropRight;
